import every from 'lodash/every';
import find from 'lodash/find';
import React from 'react';

import ImageWithText from './image-with-text';

import LinkWithText from './link-with-text';

function formatTime(timeString) {
	if (!timeString) {
		return null;
	}

	const parts = timeString.split(':');
	return `${parts[0]}:${parts[1]}`;
}

const Event = function ({
	tags,
	isExpanded,
	eventPredicates,
	event,
	itemClassName,
	prefixClassName,
}) {
	const isVisible = every(eventPredicates, (predicate) => predicate(event));
	const tag = find(tags, (t) => t.tag_id === event.tag_ids.split(',')[0]);
	const tagGroupId = tag && tag.tag_group_ids.split(',')[0];

	return (
		<li
			key={event.hash}
			className={`${itemClassName} ${
				itemClassName + '--category' + tagGroupId
			}  ${!isVisible ? itemClassName + '--hidden' : ''}`}
		>
			<div className={prefixClassName('time')}>
				{formatTime(event.time_from)}
				{event.time_to && ' — ' + formatTime(event.time_to)}
				{isExpanded && ' Uhr'}
			</div>

			<div className={prefixClassName('title')}>
				{event.title}

				{event.subtitle && <span className={prefixClassName('subtitle')}>
					{event.subtitle}
				</span>}

				<span className={prefixClassName('tags')}>
					{event.tag_names && event.tag_names.split(',').join(', ')}
				</span>
			</div>

			{isVisible && isExpanded && (
				<div className={prefixClassName('image-wrapper')}>
					<div className={prefixClassName('image-wrapper__inner')}>
						<ImageWithText
							image={event.image}
							text={event.image_text}
							prefixClassName={prefixClassName}
						/>
					</div>
				</div>
			)}

			{isVisible && isExpanded && (
				<p className={prefixClassName('description')}>
					<span
						dangerouslySetInnerHTML={{__html: event.description}}
					/>

					{event.web && (
						<LinkWithText
							className={prefixClassName('link')}
							target="_blank"
							rel="external"
							link={event.web}
							textFallback="Zur Website"
						/>
					)}
				</p>
			)}
		</li>
	);
};

export default Event;
